/** A list of marketplace fees with their split and status (docs/Decisions.md D72). */
import { LEDGER_STATUS_LABELS, PAYOUT_STATE_LABELS, formatUsd } from '../lib/marketplace';
import { formatDate } from './ui';
import { cn, ui } from '../lib/ui';

export default function FeeTable({ fees, label, show = 'vendor', onCredit }) {
  if (!fees.length) return <p className={ui.muted}>No fees yet.</p>;
  return (
    <div className={cn(ui.tableWrap, 'mb-4')} tabIndex={0} role="region" aria-label={label}>
      <table className={ui.table}>
        <thead>
          <tr>
            <th scope="col">Won</th>
            <th scope="col">{show === 'org' ? 'Vendor' : 'Deal'}</th>
            <th scope="col">Lead fee</th>
            <th scope="col">{show === 'org' ? 'Organization share' : 'You pay'}</th>
            <th scope="col">Status</th>
            {onCredit && (
              <th scope="col">
                <span className="sr-only">Actions</span>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {fees.map(f => (
            <tr key={f.entryId}>
              <td>{formatDate(f.wonAt)}</td>
              <td>
                {show === 'org' ? f.vendorName : f.serviceName}
                <span className={cn(ui.hint, 'block')}>
                  {show === 'platform' ? `${f.vendorName} - ${f.orgName || ''}` : f.orgName || ''}
                  {Number.isInteger(f.dealValueCents)
                    ? ` - deal ${formatUsd(f.dealValueCents)}`
                    : ''}
                </span>
              </td>
              <td>
                {formatUsd(f.split.leadFeeCents)}
                <span className={cn(ui.hint, 'block')}>
                  org {formatUsd(f.split.orgFeeCents)} (platform{' '}
                  {formatUsd(f.split.platformFeeCents)})
                  {f.split.rewardCents ? `, reward ${formatUsd(f.split.rewardCents)}` : ''}
                  {f.split.balanceCents
                    ? `, ${f.salespersonName || 'salesperson'} ${formatUsd(f.split.balanceCents)}`
                    : ''}
                </span>
              </td>
              <td>
                {formatUsd(show === 'org' ? f.split.orgShareCents : f.split.vendorPaysCents)}
                {show === 'org' && f.payouts?.org && (
                  <span className={cn(ui.hint, 'block')}>
                    {PAYOUT_STATE_LABELS[f.payouts.org.state]}
                  </span>
                )}
              </td>
              <td>{LEDGER_STATUS_LABELS[f.status] || f.status}</td>
              {onCredit && (
                <td>
                  {f.status === 'pending' && (
                    <button
                      type="button"
                      className={cn(ui.btnGhost, ui.btnSm)}
                      onClick={() => onCredit(f)}
                    >
                      Credit<span className="sr-only"> the fee of {f.vendorName}</span>
                    </button>
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
